import CloseIc from 'assets/img/close_btn.webp';

export default function CloseBtn({ onClick }) {
  return (
    <button style={{ textAlign: 'right' }} onClick={onClick} className='close-modal-btn'>
      <img width="30px" height="30px" src={CloseIc || ''} alt='닫기'/>
    </button>
  )
}